const plugin = require("tailwindcss/plugin");

module.exports = {
    darkMode: ["class"],
    content: ["./pages/**/*.{js,ts,jsx,tsx,mdx}", "./components/**/*.{js,ts,jsx,tsx,mdx}", "./utils/**/*.{js,ts,jsx,tsx,mdx}"],
    safelist: [
        { pattern: /^grid-/ },
        { pattern: /^col-/ },
        { pattern: /^bg-/ },
        { pattern: /^w-/ },
        {
            pattern: /^animate-/,
        },
    ],
    theme: {
        fontSize: {
            "3xs": ".6875rem",
            "2xs": ".75rem",
            xs: ".8125rem",
            sm: ".875rem",
            base: "1rem",
            lg: "1.125rem",
            xl: "1.25rem",
            "2xl": "1.5rem",
            "3xl": "1.875rem",
            "4xl": "2.25rem",
            "5xl": "3rem",
            "6xl": "4rem",
            "7xl": "5rem",
        },
        colors: {
            transparent: "transparent",
            white: "var(--color-white)",
            black: "#000000",
            primary: {
                100: "#FDECF4",
                200: "#F8CDE3",
                300: "#F4ADD1",
                400: "#F08EBF",
                500: "#EC6EAD", // 236, 110, 173
                600: "#E63C91",
                700: "#CF1B75",
                800: "#9D1559",
                900: "#6C0E3D",
                950: "#530B2F",
            },
            gray: {
                50: "var(--color-gray-50)",
                100: "var(--color-gray-100)",
                200: "var(--color-gray-200)",
                300: "var(--color-gray-300)",
                400: "var(--color-gray-400)",
                500: "var(--color-gray-500)",
                600: "var(--color-gray-600)",
                700: "var(--color-gray-700)",
                800: "var(--color-gray-800)",
                900: "var(--color-gray-900)",
                950: "var(--color-gray-950)", // rgb: 32, 36, 44
            },
            orange: {
                100: "#FFF3E0",
                200: "#FFDDA8",
                300: "#FFC770",
                400: "#FFB138",
                500: "#FF9B00", // 255, 155, 0
                600: "#C77900",
                700: "#8F5700",
                800: "#573500",
                900: "#1F1300",
            },
            red: {
                100: "#FCDADA",
                200: "#F8A6A6",
                300: "#F37272",
                400: "#EF3E3E",
                500: "#E21313", // 226, 19, 19
                600: "#AE0F0F",
                700: "#7B0A0A",
                800: "#470606",
                900: "#130202",
            },
            green: {
                100: "#DCF9D9",
                200: "#ACF1A3",
                300: "#7DE96E",
                400: "#4DE139",
                500: "#30C01D", // 48, 192, 29
                600: "#248F16",
                700: "#185F0E",
                800: "#0B2E07",
                900: "#000000",
            },
            yellow: {
                100: "#FCF9DC",
                200: "#F9F3B7",
                300: "#F5ED91",
                400: "#F2E76C",
                500: "#EFE146", // 239, 225, 70
                600: "#E9D714",
                700: "#B5A710",
                800: "#82780B",
                900: "#4E4807",
            },
            blue: {
                100: "#D2EAFF",
                200: "#9FD3FF",
                300: "#6DBBFE",
                400: "#3AA4FE",
                500: "#078CFE", // 7, 140, 254
                600: "#016ECC",
                700: "#015094",
                800: "#00325C",
                900: "#001424",
            },
            purple: {
                100: "#EDDFFF",
                200: "#CDA7FE",
                300: "#AD6FFE",
                400: "#8D38FD",
                500: "#6E02FB", // 110, 2, 151
                600: "#5602C3",
                700: "#3D018C",
                800: "#250154",
                900: "#0C001C",
            },
            pink: {
                100: "#FDECF4",
                200: "#F8CDE3",
                300: "#F4ADD1",
                400: "#F08EBF",
                500: "#EC6EAD", // 236, 110, 173
                600: "#E63C91",
                700: "#CF1B75",
                800: "#9D1559",
                900: "#6C0E3D",
                950: "#530B2F",
            },
        },
        boxShadow: {
            DEFAULT: "var(--box-shadow)",
            button: "var(--box-shadow-button)",
            "button-primary":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(236, 110, 173, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(236, 110, 173, 0.08) 0px 2px 5px 0px",
            "button-orange":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(255, 155, 0, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(255, 155, 0, 0.08) 0px 2px 5px 0px",
            "button-red":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(226, 19, 19, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(226, 19, 19, 0.08) 0px 2px 5px 0px",
            "button-green":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(48, 192, 29, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(48, 192, 29, 0.08) 0px 2px 5px 0px",
            "button-yellow":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(239, 225, 70, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(239, 225, 70, 0.08) 0px 2px 5px 0px",
            "button-blue":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(7, 140, 254, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(7, 140, 254, 0.08) 0px 2px 5px 0px",
            "button-purple":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(110, 2, 151, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(110, 2, 151, 0.08) 0px 2px 5px 0px",
            "button-pink":
                "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px, rgba(236, 110, 173, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(236, 110, 173, 0.08) 0px 2px 5px 0px",
            "button-focus": "var(--box-shadow-button-focus)",
            "button-primary-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(236, 110, 173, 0.3) 0px 0px 0px 4px",
            "button-orange-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(255, 155, 0, 0.3) 0px 0px 0px 4px",
            "button-red-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(226, 19, 19, 0.3) 0px 0px 0px 4px",
            "button-green-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(48, 192, 29, 0.3) 0px 0px 0px 4px",
            "button-yellow-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(239, 225, 70, 0.3) 0px 0px 0px 4px",
            "button-blue-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(7, 140, 254, 0.3) 0px 0px 0px 4px",
            "button-purple-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(110, 2, 151, 0.3) 0px 0px 0px 4px",
            "button-pink-focus":
                "0 0 0 1px rgba(32, 36, 44, .05), 0 2px 5px 0 rgba(32, 36, 44, .05), 0 1px 2.5px 0 rgba(32, 36, 44, .05), 0 1px 2px 0 rgba(32, 36, 44, .05), rgba(236, 110, 173, 0.3) 0px 0px 0px 4px",
            box: "var(--box-shadow-box)",
            "box-light": "var(--box-shadow-box-light)",
            "box-extra-light": "var(--box-shadow-box-extra-light)",
            card: "var(--box-shadow-card)",
            "keyboard-navigation": "0 0 0 2px #427DDD, inset 0 0 0 2px hsla(0, 0%, 100%, 0.9)",
            none: "none",
        },
        transitionProperty: {
            DEFAULT:
                "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
            none: "none",
            all: "all",
            shadow: "box-shadow",
            transform: "transform",
            opacity: "opacity",
            move: "transform, opacity, width, height, top, left, visibility",
            colors: "background-color, border-color, color, fill, stroke",
            width: "width",
        },
        borderRadius: {
            DEFAULT: "4px",
            md: "6px",
            lg: "8px",
            xl: "16px",
            full: "9999px",
            none: "0",
        },
        transitionDuration: {
            200: "200ms",
            300: "300ms",
            600: "600ms",
            900: "900ms",
        },
        transitionTimingFunction: {
            "out-cubic": "cubic-bezier(0.215, 0.610, 0.355, 1.000)",
            "in-out-cubic": "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
            "in-out-expo": "cubic-bezier(1.000, 0.000, 0.000, 1.000)",
            "in-out-quart": "cubic-bezier(0.770, 0.000, 0.180, 1.000);",
            "out-back": "cubic-bezier(.26,2.05,.59,1.14)",
            "out-expo": "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
            "in-out-custom": "cubic-bezier(0.620, 0.020, 0.070, 1.000)",
        },
        animation: {
            none: "none",
            spin: "spin 600ms linear infinite",
            "spin-slow": "spin 50000ms linear infinite",
            loading: "loading 2s linear infinite",
            shimmer: "shimmer 1.7s linear infinite",
            "pulse-ring": "pulse-ring 1.25s cubic-bezier(0.215, 0.610, 0.355, 1.000) infinite",
            "pulse-dot": "pulse-dot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite",
            "enter-top": "enter-top 0.2s ease-out forwards",
            "leave-top": "leave-top 0.2s ease-in forwards",
            "enter-bottom": "enter-bottom 0.2s ease-out forwards",
            "leave-bottom": "leave-bottom 0.2s ease-in forwards",
        },
        keyframes: {
            spin: {
                from: {
                    transform: "rotate(0deg)",
                },
                to: {
                    transform: "rotate(360deg)",
                },
            },
            loading: {
                from: {
                    "background-position": "0 0",
                },
                to: {
                    "background-position": "50px 50px",
                },
            },
            "pulse-ring": {
                "0%": {
                    transform: "scale(.33)",
                },
                "80%": {
                    opacity: "0",
                },
                "100%": {
                    opacity: "0",
                },
            },
            "pulse-dot": {
                "0%": {
                    transform: "scale(.8)",
                },
                "50%": {
                    transform: "scale(1)",
                },
                "100%": {
                    transform: "scale(.8)",
                },
            },
            shimmer: {
                "100%": {
                    transform: "translateX(100%)",
                },
            },
            "enter-top": {
                "0%": { transform: "translateY(-10px)", opacity: "0" },
                "100%": { transform: "translateY(0)", opacity: "1" },
            },
            "leave-top": {
                "0%": { transform: "translateY(0)", opacity: "1" },
                "100%": { transform: "translateY(-10px)", opacity: "0" },
            },
            "enter-bottom": {
                "0%": { transform: "translateY(10px)", opacity: "0" },
                "100%": { transform: "translateY(0)", opacity: "1" },
            },
            "leave-bottom": {
                "0%": { transform: "translateY(0)", opacity: "1" },
                "100%": { transform: "translateY(10px)", opacity: "0" },
            },
        },
        extend: {
            maxWidth: {
                "screen-3xl": "1920px",
                "screen-4xl": "2164px",
            },
            rotate: {
                270: "270deg",
            },
            transitionDelay: {
                250: "250ms",
                350: "350ms",
                400: "400ms",
                450: "450ms",
                600: "600ms",
                800: "800ms",
                900: "900ms",
                1100: "1100ms",
                1200: "1200ms",
                1300: "1300ms",
                1400: "1400ms",
            },
            /* old start */
            borderWidth: {
                3: "3px",
            },
            screens: {
                uwd: "3440px",
                "4k": "3840px",
            },
            transformOrigin: {
                0: "0%",
            },
            spacing: {
                480: "30rem",
                560: "35rem",
                672: "42rem",
                950: "59rem",
                "50%": "50%",
            },
            height: {
                "screen/2": "50vh",
                "screen-3/4": "75vh",
                18: "4.25rem",
                500: "500px",
            },
            minHeight: {
                "screen/2": "50vh",
                96: "24rem",
            },
            colors: {
                "rc-background": "#1F1F1F",
                "rc-dark": "#161616",
                "rc-darker": "#141414",
                "rc-black": "#111111",
                "rc-pink": "#EC6EAD",
                "rc-blue": "#3494E6",
                "rc-gray-light": "#8C8C8C",
                "rc-gray-dark": "#555555",
                "rc-gray-white": "#E4E4E4",
                "rc-white": "#E4E4E4",
                "rc-black-light": "#1F1F1F",
                "rc-grey": "#F0F1F3",
            },
            fontFamily: {
                karla: ["Open Sans", "sans-serif"],
                oswald: ["Oswald", "sans-serif"],
            },
            animation: {
                tilt: "tilt",
                "gradient-x": "gradient-x 5s ease infinite",
                "gradient-y": "gradient-y 5s ease infinite",
                "gradient-xy": "gradient-xy 2s ease infinite",
                blink: "blink 1s infinite",
                "fade-in": "fade-in 2s",
                "fade-out": "fade-out 2s",
                "fade-in-500ms": "fade-in 500ms",
                "fade-out-500ms": "fade-out 500ms",
                "fade-in-1s": "fade-in 1s",
                "fade-out-1s": "fade-out 1s",
                "fade-in-fast": "fade-in 200ms",
                "fade-out-fast": "fade-out 250ms",
                "scale-enlarge": "scale-enlarge ease-in-out 200ms",
                "scale-shrink": "scale-shrink ease-in-out 300ms",
                shine: "shine 1s",
                "spin-slow": "spinSlow 30s linear infinite",
            },
            keyframes: {
                spinSlow: {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                },
                tilt: {
                    "0%, 50%, 100%": {
                        transform: "rotate(0deg)",
                    },
                    "25%": {
                        transform: "rotate(1deg)",
                    },
                    "75%": {
                        transform: "rotate(-1deg)",
                    },
                },
                "gradient-y": {
                    "0%, 100%": {
                        "background-size": "400% 400%",
                        "background-position": "center top",
                    },
                    "50%": {
                        "background-size": "200% 200%",
                        "background-position": "center center",
                    },
                },
                "gradient-x": {
                    "0%, 100%": {
                        "background-size": "200% 200%",
                        "background-position": "left center",
                    },
                    "50%": {
                        "background-size": "200% 200%",
                        "background-position": "right center",
                    },
                },
                "gradient-xy": {
                    "0%, 100%": {
                        "background-size": "400% 400%",
                        "background-position": "left center",
                    },
                    "50%": {
                        "background-size": "200% 200%",
                        "background-position": "right center",
                    },
                },
                blink: {
                    "0%, 100%": { opacity: "1" },
                    "50%": { opacity: "0" },
                },
                "fade-in": {
                    "0%": { opacity: "0" },
                    "100%": { opacity: "1" },
                },
                "fade-out": {
                    "0%": { opacity: "1" },
                    "100%": { opacity: "0" },
                },
                "scale-enlarge": {
                    "0%": { transform: "scale(0.90)", opacity: "0" },
                    "100%": { transform: "scale(1)", opacity: "1" },
                },
                "scale-shrink": {
                    "0%": { transform: "scale(1)", opacity: "1" },
                    "100%": { transform: "scale(0.90)", opacity: "0" },
                },
                shine: {
                    "100%": { left: "125%" },
                },
            },
            scale: { 25: ".25", 60: ".6" },
            gridTemplateColumns: {
                shopping: "minmax(200px, 1fr) 4fr",
                "shopping-filters": "minmax(0, 4fr) minmax(0, 2fr)",
            },
            /* old end */
        },
    },
    variants: {
        extend: {
            cursor: ["hover", "focus", "disabled"],
            animation: ["hover", "focus"],
            gradientColorStops: ["active", "group-hover"],
            translate: ["active", "group-hover"],
            borderWidth: ["hover", "focus"],
            transformOrigin: ["hover", "focus"],
            backgroundColor: ["checked", "focus", "hover"],
            borderColor: ["checked"],
            scale: ["hover"],
            opacity: ["dark", "disabled"],
            display: ["group-hover"],
            textColor: ["group-hover"],
        },
    },
    plugins: [
        require("tailwind-css-variables")(
            {
                // modules
            },
            {
                // options
            },
        ),
    ],
};
